<script setup>
/* eslint-disable no-unused-vars */
import auth from "@/api/auth/auth";
import NotificationService from "@/utils/plugins/NotificationService";

import { ref } from "vue";
import { useRoute, useRouter } from "vue-router";

const route = useRoute();
const router = useRouter();

const password = ref('');
const repeatPassword = ref('');
const showPassword = ref(false);
const showRepeatPassword = ref(false);
const submitted = ref(false);

function submit() {
  submitted.value = true;

  if (password.value !== repeatPassword.value) {
    NotificationService.addNotification('Las contraseñas deben ser iguales', 'warning', 6000);
    return;
  }

  const token = route.query.token;
  if (!token) {
    NotificationService.addNotification('Enlace de recuperación no válido', 'error', 6000);
    return;
  }

  auth.confirmRecovery(token, password.value, repeatPassword.value)
    .then(() => {
      NotificationService.addNotification('Contraseña restablecida correctamente, ya puede iniciar sesión', 'success', 6000);
      router.push({ name: 'login' });
    })
    .catch((error) => {
      // El back responde 422 tanto por contraseña débil como por token inválido/caducado:
      // se muestra su mensaje en vez de asumir siempre que el enlace ha caducado.
      const message = error.response?.data?.error
        ?? 'No se ha podido restablecer la contraseña, inténtelo de nuevo';
      NotificationService.addNotification(message, 'error', 8000);
    });
}
</script>

<template>
  <div class="background">
    <div id="banana">
      <img src="../../assets/images/login_hola_banana.png" alt="" srcset="">
    </div>
    <div id="login" class="animated fadeIn fast">
      <div>
        <img class="logo-connectus mb-3" src="../../assets/images/logo_ConnectUs_png_25.png" alt="">
      </div>
      <div>
        <img class="mb-4" src="../../assets/images/dots.png" alt="">
      </div>
      <div class="form-item">
        <input id="password" v-model="password" :type="showPassword ? 'text' : 'password'" name="password"
          class="login" placeholder="Nueva contraseña" @keyup.enter="submit">
        <font-awesome-icon class="eye pointer" :icon="showPassword ? 'eye-slash' : 'eye'"
          @click="showPassword = !showPassword" />
      </div>
      <div class="form-item">
        <input id="repeatPassword" v-model="repeatPassword" :type="showRepeatPassword ? 'text' : 'password'"
          name="repeatPassword" class="login" placeholder="Confirmar contraseña" @keyup.enter="submit">
        <font-awesome-icon class="eye pointer" :icon="showRepeatPassword ? 'eye-slash' : 'eye'"
          @click="showRepeatPassword = !showRepeatPassword" />
      </div>
      <p class="password-hint mt-3">
        Mínimo 12 caracteres, con al menos una mayúscula, un número y un símbolo.
      </p>
      <div class="d-flex flex-column">
        <button class="btn btn-block btn_yellow btn__login mt-4" @click="submit()">
          Restablecer contraseña
        </button>
        <button class="btn btn-block btn_purple btn__login mt-4" @click="router.push({ name: 'login' })">
          Volver a inicio de sesión
        </button>
      </div>
    </div>
    <div id="aspas">
      <img class="aspa-big" src="../../assets/images/aspa_amarilla_small_entrada.png" alt="" srcset="">
      <img class="aspa-small" src="../../assets/images/aspa_amarilla_small_entrada.png" alt="" srcset="">
      <img class="estrella-white" src="../../assets/images/estrella_blanca_entrada.png" alt="" srcset="">
      <img class="logo-undanet" src="../../assets/images/logo-undanet.png" alt="" srcset="">
    </div>
  </div>
</template>

<style lang="scss" scoped>
input:-webkit-autofill,
input:-webkit-autofill:hover,
input:-webkit-autofill:focus {
  -webkit-text-fill-color: white;
  -webkit-box-shadow: 0 0 0px 1000px #474ce6 inset;
}

.password-hint {
  color: white;
  font-size: 0.85rem;
  max-width: 300px;
}

.logo-connectus {
  filter: brightness(1);
}

.aspa-big {
  position: absolute;
  top: 15%;
  right: calc(60% - 40px);
  width: 80px;
  transition: all 0.3s linear;
}

.aspa-small {
  position: absolute;
  top: 41%;
  right: calc(100% - 45px);
  width: 45px;
  transition: all 0.3s linear;
}

.estrella-white {
  position: absolute;
  bottom: 20%;
  right: calc(50% - 15px);
  width: 30px;
  filter: brightness(1);
  transition: all 0.3s linear;
}

.logo-undanet {
  position: absolute;
  bottom: 2%;
  right: 20px;
  width: 200px;
  filter: brightness(1);
  transition: all 0.3s linear;
}

.background {
  display: flex;
  background: #474ce6;
  width: 100vw;
  height: 100vh;
}

.login {
  background: #474ce6;
  padding: 0;
  border: none;
  border-radius: 0;
  border-bottom: 1px solid white !important;
  color: white;

  &:focus {
    background: #474ce6;
    color: white;
    padding: 0;
    border: none;
    border-radius: 0;
    border-bottom: 2px solid white;
  }

  &::placeholder {
    color: white;
  }
}

#banana {
  width: 50%;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  transition: all 0.3s linear, order 0s linear;

  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
    margin-right: -10%;
  }
}

#aspas {
  width: 25%;
  position: relative;
  margin-left: auto;
  transition: all 0.3s linear, order 0s linear;
}

#login {
  top: calc(40% - 220px);
  left: 45%;
  max-width: 100%;
  width: 450px;
  height: 440px;
  z-index: 1;
  position: absolute;
  background-color: transparent;
  padding: 4rem;
  margin: auto;
  display: flex;
  justify-content: center;
  flex-direction: column;
  border-radius: 5%;
  transition: all 0.3s linear, order 0s linear;

  .btn__login {
    margin-top: 1.5em;
    height: 3em;
    border-radius: 30px;
  }

  img {
    max-width: 100%;
  }
}

@media (max-width: 570px) {

  .aspa-big,
  .aspa-small,
  .estrella-white {
    display: none;
  }

  #login,
  #banana {
    height: 50%;
  }

  #banana {
    margin-top: -40px;
    padding-left: 5px;

    img {
      width: 95%;
    }
  }
}
</style>
